<script>
import {BButton} from "bootstrap-vue";

export default {
    name: "JustificatifButton",
    components: {BButton},
    props: {
        row: {
            type: Object,
            required: true,
        },
        url: {
            type: String,
            required: true
        }
    }
}
</script>

<template>
    <div>
        <span
            tabindex="0"
            v-if="!row.value"
            v-b-tooltip.hover.bottom="'Aucune pièce justificative n\'existe pour cette saisie.'">
                <b-button size="sm"
                          disabled
                          href="#"
                >
                    <Icon icon="edit" size="1x"></Icon>
                </b-button>
        </span>
        <b-button
            v-else
            size="sm"
            :href="`${url}/${row.value}`"
        >
            <Icon icon="edit" size="1x"></Icon>
        </b-button>
    </div>
</template>
